(function() {
  'use strict';

  var FOCUSABLE =
    'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getFocusableElements(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function createFocusTrap(container) {
    var previousFocus = null;

    function handleKeyDown(e) {
      if (e.key !== 'Tab') return;

      var nodes = getFocusableElements(container);
      if (!nodes.length) {
        e.preventDefault();
        return;
      }

      var first = nodes[0];
      var last = nodes[nodes.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    return {
      activate: function(initialFocus) {
        previousFocus = document.activeElement;
        container.addEventListener('keydown', handleKeyDown);

        var target = initialFocus;
        if (!target || !container.contains(target)) {
          target = getFocusableElements(container)[0];
        }

        if (target) target.focus();
      },
      deactivate: function() {
        container.removeEventListener('keydown', handleKeyDown);

        if (previousFocus && typeof previousFocus.focus === 'function') {
          try {
            previousFocus.focus();
          } catch (err) {}
        }

        previousFocus = null;
      }
    };
  }

  function announceLiveRegion(id, message) {
    var el = document.getElementById(id);
    if (!el || !message) return;

    el.textContent = '';
    window.setTimeout(function() {
      el.textContent = message;
    }, 50);
  }

  function initSkipLink() {
    var skipLink = document.querySelector('[data-skip-link]');
    var main = document.getElementById('MainContent');

    if (!skipLink || !main) return;

    skipLink.addEventListener('click', function() {
      main.focus({ preventScroll: false });
    });
  }

  window.EzsportA11y = {
    createFocusTrap: createFocusTrap,
    announce: announceLiveRegion,
    initSkipLink: initSkipLink
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkipLink);
  } else {
    initSkipLink();
  }
})();
